import React, { createContext, useContext } from 'react';
import useBusiness4FlyoCheckIns from '../hooks/useBusiness4FlyoCheckIns';

// Create context
const Business4FlyoCheckInContext = createContext(null);

/**
 * Provider component for Business4Flyo check-in data
 * @param {Object} props - Component props
 * @returns {JSX.Element} Provider component
 */
export const Business4FlyoCheckInProvider = ({ children }) => {
  const checkInData = useBusiness4FlyoCheckIns();
  
  return (
    <Business4FlyoCheckInContext.Provider value={checkInData}>
      {children}
    </Business4FlyoCheckInContext.Provider>
  );
};

/**
 * Custom hook to use the Business4Flyo check-in context
 * @returns {Object} Business4Flyo check-in context value
 */
export const useBusiness4FlyoCheckInContext = () => {
  const context = useContext(Business4FlyoCheckInContext);
  
  if (!context) {
    throw new Error('useBusiness4FlyoCheckInContext must be used within a Business4FlyoCheckInProvider');
  }
  
  return context;
};

export default Business4FlyoCheckInContext;

